// State 

export default {
	standards: [],
	filteredStandards: [],
	standardsSearchTerm: '',

	showSearch: false,
	searchTerm: "",
	entries: [],

	showMenu: false,

	sortOrder: "asc",
	sortKey: null,

	showWithdrawn: false,

	members: [],

	main_menu: [],
	main_menu_flat: [],

	categories: []
}